import { defaultGlobalDragDropStates } from '../../hooks/useGlobalDragDropHook';
import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

const mappingsActions = mapDefaultValuesToActions(defaultGlobalDragDropStates);

export default reduxReducerHelper(mappingsActions, defaultGlobalDragDropStates);
